<template>
  <span>
    <v-icon v-if="item.Type === notificationTypes.Warning || item.Type === notificationTypes.FeedBack" color="warning" class="short-icon">
      mdi-alert
    </v-icon>
    <v-icon v-if="item.Type === notificationTypes.Info" color="info" class="short-icon">mdi-information</v-icon>
    <v-icon v-if="item.Type === notificationTypes.Tip" color="warning" class="short-icon">mdi-lightbulb</v-icon>
    <v-icon v-if="item.Type === notificationTypes.Kudos" color="Primary" class="short-icon">mdi-thumb-up</v-icon></span
  >
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { NotificationType } from "../../definitions/constants";

export default defineComponent({
  components: {},
  props: ["item"],
  data() {
    return {
      notificationTypes: NotificationType,
    };
  },
});
</script>
